import { Badge } from 'antd'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'i18next'
import GlobalContext from '../GlobalContext'
import { Color } from '../../Common/Color'

export default function BoxBadge () {
  const { boxes } = useContext(GlobalContext)

  const errorCount = (boxes || []).filter((box) => box.has_problem).length

  return (
    <Badge count={errorCount} style={{ '--ant-color-text': Color.primary }}>
      <Link to={'/admin/boxes'} style={{ fontSize: '24px' }}>
        {t('Admin.Menu.boxes')}
      </Link>
    </Badge>
  )
}
